// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"9bb0c15d","886":"4ee45ea0"}[chunkId] + ".chunk.js";
};